import React  from 'react';
import { GlobalHotKeys } from 'react-hotkeys';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import EditIcon from '@material-ui/icons/Edit';

const noOp = () => {};

const useCommentItemStyles = makeStyles(theme => ({
  root: {
    padding: '0.4em',
    border: '1px solid #000',
    '&:hover': { background: '#EFEFEF' }
  }
}));

const getEditIfAllowed = (comment, openDialogAction, encounterId, isReview) => {
  if (isReview || (comment.canBeEdited === false && comment.canBeDeleted === false)) return null;

  return (
    <span><a title="Edit" style={{ cursor: "pointer", zoom: "85%", position: "relative", top: "4px", color: "rgb(255, 152, 0)" }} onClick={() => { openDialogAction(encounterId, comment.commentId, comment.commentText.trim(), comment.commentSourceType, true, comment.canBeDeleted, comment.canBeEdited, comment.isHoldComment, comment.isActive);}}><EditIcon height="10px" /></a></span>
  );
}

const CommentItem = ({ comment, openCommentDialog, encounterId, isReview }) => {
  const classes = useCommentItemStyles();
  const backGroundColor = comment.isActive ? 'white' : 'lightgrey';
  const textColor = comment.isActive ? 'black' : 'grey';
  const commentSource = comment.commentSourceType === 'Patient' ? 'P' : 'E';

  let commentText = `${comment.commentText} | Created On: ${comment.createdOnString}`;

  if (comment.isActive == false) commentText = `INACTIVE - ${commentText}`;

  return (
    <div className={classes.root} style={{ backgroundColor: backGroundColor, color: textColor }}>
      {getEditIfAllowed(comment, openCommentDialog, encounterId, isReview)}
      <span><strong>{comment.createdBy} ({commentSource}): </strong></span>
      <span>{commentText}</span>&nbsp;

    </div>
  );
};

const useCommentSectionStyles = makeStyles(theme => ({
  listContainer: {
    '& div + div': { marginTop: '0.4em' }
  },
  addButtonContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0.4em'
  }
}));

const CommentSection = ({
  openAddCommentDialog,
  encounterId,
  comments,
  isAudit = false,
  isReview = false
}) => {
  const classes = useCommentSectionStyles();

  const openAddCommentHandler = (isReview) ? noOp : openAddCommentDialog;

  const keyHandlers = {
    OPEN_COMMENTS: event => {
      event.preventDefault();
      openAddCommentHandler(encounterId, 0, '', 'CoreEncounter', false, false, false, false, true);
    }
  };

  return (
    <GlobalHotKeys handlers={keyHandlers}>
    <div>
      {/* Comments Button */}
      <div className={classes.addButtonContainer}>
        <button
          disabled={isReview}
          onClick={() => openAddCommentDialog(encounterId, 0, '', 'CoreEncounter', false, false, false, false, true)}
        >
          <span>Add Comment ({comments.length})</span>
        </button>
      </div>

      <h4 style={{ margin: '0.3em' }}>Patient Comments:</h4>

      <div className={classes.listContainer}>
        {
          comments.map(x => (
            <CommentItem
              key={x.commentId}
              comment={x}
              openCommentDialog={openAddCommentDialog}
              encounterId={encounterId}
              isReview={isReview}
            />
          ))
        }
      </div>
    </div>
    </GlobalHotKeys>
  );
};

CommentSection.propTypes = {
  openAddCommentDialog: PropTypes.func.isRequired,
  comments: PropTypes.array.isRequired,
  isAudit: PropTypes.bool.isRequired,
  isReview: PropTypes.bool.isRequired
};

export default CommentSection;
